/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Releasedate_Theegs3Inputs */

const id_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` EGS`)
};

const ms_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` EGS`)
};

const da_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` EGS`)
};

const de_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` der EGS`)
};

const en_us2_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` the EGS`)
};

const es_es2_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` la EGS`)
};

const es_mx2_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` la EGS`)
};

const fil_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` sa EGS`)
};

const fr_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` l'EGS`)
};

const it_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` su EGS`)
};

const hu_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` az EGS-en`)
};

const nl_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` op de EGS`)
};

const no_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` på EGS`)
};

const pl_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` w EGS`)
};

const pt_br2_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` a EGS`)
};

const pt_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` na EGS`)
};

const ro_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` pe EGS`)
};

const fi_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` EGS:ään`)
};

const sv_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` på EGS`)
};

const vi_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGS`)
};

const tr_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGS`)
};

const cs_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGS`)
};

const bg_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGS`)
};

const ru_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGS`)
};

const uk_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` в EGS`)
};

const ar_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` على EGS`)
};

const hi_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` EGS पर`)
};

const th_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` บน EGS`)
};

const ja_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` EGS`)
};

const zh_cn2_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Epic游戏商城`)
};

const zh_hant1_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Epic遊戲商城`)
};

const ko_offerdetail_releasedate_theegs3 = /** @type {(inputs: Offerdetail_Releasedate_Theegs3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` EGS`)
};

/**
* | output |
* | --- |
* | "the EGS" |
*
* @param {Offerdetail_Releasedate_Theegs3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_releasedate_theegs3 = /** @type {((inputs?: Offerdetail_Releasedate_Theegs3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Releasedate_Theegs3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_releasedate_theegs3(inputs)
	if (locale === "ms") return ms_offerdetail_releasedate_theegs3(inputs)
	if (locale === "da") return da_offerdetail_releasedate_theegs3(inputs)
	if (locale === "de") return de_offerdetail_releasedate_theegs3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_releasedate_theegs3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_releasedate_theegs3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_releasedate_theegs3(inputs)
	if (locale === "fil") return fil_offerdetail_releasedate_theegs3(inputs)
	if (locale === "fr") return fr_offerdetail_releasedate_theegs3(inputs)
	if (locale === "it") return it_offerdetail_releasedate_theegs3(inputs)
	if (locale === "hu") return hu_offerdetail_releasedate_theegs3(inputs)
	if (locale === "nl") return nl_offerdetail_releasedate_theegs3(inputs)
	if (locale === "no") return no_offerdetail_releasedate_theegs3(inputs)
	if (locale === "pl") return pl_offerdetail_releasedate_theegs3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_releasedate_theegs3(inputs)
	if (locale === "pt") return pt_offerdetail_releasedate_theegs3(inputs)
	if (locale === "ro") return ro_offerdetail_releasedate_theegs3(inputs)
	if (locale === "fi") return fi_offerdetail_releasedate_theegs3(inputs)
	if (locale === "sv") return sv_offerdetail_releasedate_theegs3(inputs)
	if (locale === "vi") return vi_offerdetail_releasedate_theegs3(inputs)
	if (locale === "tr") return tr_offerdetail_releasedate_theegs3(inputs)
	if (locale === "cs") return cs_offerdetail_releasedate_theegs3(inputs)
	if (locale === "bg") return bg_offerdetail_releasedate_theegs3(inputs)
	if (locale === "ru") return ru_offerdetail_releasedate_theegs3(inputs)
	if (locale === "uk") return uk_offerdetail_releasedate_theegs3(inputs)
	if (locale === "ar") return ar_offerdetail_releasedate_theegs3(inputs)
	if (locale === "hi") return hi_offerdetail_releasedate_theegs3(inputs)
	if (locale === "th") return th_offerdetail_releasedate_theegs3(inputs)
	if (locale === "ja") return ja_offerdetail_releasedate_theegs3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_releasedate_theegs3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_releasedate_theegs3(inputs)
	return ko_offerdetail_releasedate_theegs3(inputs)
});
export { offerdetail_releasedate_theegs3 as "offerDetail.releaseDate.theEgs" }